// import React from "react";
// import { Bot, Mail, MessageCircle } from "lucide-react";

// const Footer = () => {
//   return (
//     <footer className="bg-black text-gray-300 py-12">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//           {/* Brand Section */}
//           <div className="space-y-4">
//             <div className="flex items-center space-x-2">
//               <Bot className="text-blue-400" size={24} />
//               <h2 className="text-2xl font-bold text-white">[Your Name]</h2>
//             </div>
//             <p className="text-sm text-gray-400">
//               Software Engineer | AI & Automation Specialist
//             </p>
//           </div>

//           {/* Quick Links */}
//           <div className="space-y-4">
//             <h3 className="text-white font-medium">Quick Links</h3>
//             <ul className="space-y-2 text-sm">
//               <li>
//                 <a href="#about" className="hover:text-blue-400 transition">
//                   About Me
//                 </a>
//               </li>
//               <li>
//                 <a href="#services" className="hover:text-blue-400 transition">
//                   Services
//                 </a>
//               </li>
//               <li>
//                 <a href="#contact" className="hover:text-blue-400 transition">
//                   Contact
//                 </a>
//               </li>
//             </ul>
//           </div>

//           {/* Contact Info */}
//           <div className="space-y-4">
//             <h3 className="text-white font-medium">Contact</h3>
//             <ul className="space-y-2 text-sm">
//               <li className="flex items-center space-x-2">
//                 <Mail size={16} />
//                 <a
//                   href="mailto:your.email@example.com"
//                   className="hover:text-blue-400 transition"
//                 >
//                   your.email@example.com
//                 </a>
//               </li>
//               <li className="flex items-center space-x-2">
//                 <MessageCircle size={16} />
//                 <span>Let’s build something great!</span>
//               </li>
//             </ul>
//           </div>
//         </div>

//         {/* Bottom Bar */}
//         <div className="pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
//           © 2024 [Your Name]. All rights reserved.
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React from "react";
import {
  Bot,
  MessageCircle,
  Mail,
  Cpu,
  Code,
  Smartphone,
  Building,
} from "lucide-react";

const Footer = ({ darkMode }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className={`${
        darkMode
          ? "bg-black border-t border-gray-900"
          : "bg-white border-t border-gray-100"
      }`}
    >
      <div className="container mx-auto px-6 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div className="space-y-4 md:col-span-2">
            <div className="flex items-center space-x-2">
              <div className="relative">
                <Bot className="text-blue-600 w-6 h-6 relative z-10" />
                <div className="absolute -inset-1 bg-blue-500/20 rounded-full blur-sm"></div>
              </div>
              <h2
                className={`text-2xl font-bold font-mono ${
                  darkMode ? "text-white" : "text-black"
                }`}
              >
                TK<span className="text-blue-600">.</span>
              </h2>
            </div>
            <p className="text-sm text-gray-500 dark:text-gray-400 max-w-md">
              Building intelligent solutions at the intersection of AI and
              software development. Specialized in creating conversational AI
              agents and custom automation workflows for businesses across South
              Africa.
            </p>
            <div className="flex items-center space-x-1">
              <span className="h-2 w-2 bg-green-400 rounded-full animate-pulse"></span>
              <span className="text-xs text-green-400 font-mono">
                Available for projects
              </span>
            </div>
          </div>

          {/* Services Links */}
          <div className="space-y-4">
            <h3
              className={`font-medium font-mono ${
                darkMode ? "text-white" : "text-black"
              }`}
            >
              Services
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="#services"
                  className="flex items-center text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors"
                >
                  <Bot className="w-4 h-4 mr-2 text-gray-400 dark:text-gray-500" />
                  <span>AI Agents</span>
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="flex items-center text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors"
                >
                  <Cpu className="w-4 h-4 mr-2 text-gray-400 dark:text-gray-500" />
                  <span>Business Automation</span>
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="flex items-center text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors"
                >
                  <Code className="w-4 h-4 mr-2 text-gray-400 dark:text-gray-500" />
                  <span>Web Development</span>
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="flex items-center text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors"
                >
                  <Smartphone className="w-4 h-4 mr-2 text-gray-400 dark:text-gray-500" />
                  <span>Mobile Apps</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3
              className={`font-medium font-mono ${
                darkMode ? "text-white" : "text-black"
              }`}
            >
              Connect
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="mailto:tresorlundimu@gmail.com"
                  className="flex items-center text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors"
                >
                  <Mail className="w-4 h-4 mr-2 text-gray-400 dark:text-gray-500" />
                  <span>tresorlundimu@gmail.com</span>
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/yourusername"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors"
                >
                  <svg
                    className="w-4 h-4 mr-2 text-gray-400 dark:text-gray-500"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                  </svg>
                  <span>GitHub</span>
                </a>
              </li>
              <li>
                <a
                  href="https://linkedin.com/in/yourusername"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors"
                >
                  <svg
                    className="w-4 h-4 mr-2 text-gray-400 dark:text-gray-500"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                  <span>LinkedIn</span>
                </a>
              </li>
              <li>
                <a
                  href="https://tresorkl.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors"
                >
                  <Building className="w-4 h-4 mr-2 text-gray-400 dark:text-gray-500" />
                  <span>tresorkl.com</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className={`pt-8 border-t ${
            darkMode ? "border-gray-800" : "border-gray-200"
          } flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0`}
        >
          <div className="text-sm text-gray-500 dark:text-gray-400">
            © {currentYear} Tresor Kwabezagwa. All rights reserved.
          </div>

          <div className="flex items-center space-x-2 bg-blue-500/10 px-3 py-1 rounded-full">
            <MessageCircle size={14} className="text-blue-500" />
            <span className="text-xs text-blue-500 dark:text-blue-400 font-mono">
              Available for freelance opportunities
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
